import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { CheckboxOption, CheckboxValue, TemplateCheckboxComponent } from "../../templates/template-checkbox/template-checkbox.component";

@Component({
  standalone: true,
  selector: "app-prefix-jn3",
  imports: [TemplateCheckboxComponent],
  templateUrl: "./prefix-jn3.component.html",
  styleUrl: "./prefix-jn3.component.less",
})
export class PrefixJn3Component extends PrefixComponent<CheckboxValue> {
  @Input()
  public options: CheckboxOption[];

  public constructor() {
    super();
    this.options = [];
    this.characters = ALLOWED_CHARACTERS["jn3"];
  }
}
